<template>
    <div></div>
</template>

<script>
export default {
    name: 'clarity',
    data() {
        return {
            clarityId: 'b9lossnys7',
        };
    },
    beforeCreate() {
        
    },
    created() {
        if (window.location.host.split('.')[0] === 'nl') {
            this.clarityId = 'b9lpmn2htz';
        }
        if (process.env.NODE_ENV !== 'development') {
            /* eslint-disable */
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", this.clarityId);
            /* eslint-enable */
        }
    },
};
</script>
